module.exports = __webpack_public_path__ + "static/media/close-icon.db218e9a.svg";